export const mit = {
    fontFamilyImport: [],
  transitionMain: "all 300ms ease-in-out",

  fieldTopSpacing: 57,
  inputPaddingInline: 14,

  inputHeight: 45,
  inputWidth: '100',
  inputWidthUnits: "%",

  inputFontSize: 18,
  inputFontFamily: '"Raleway", sans-serif',
  inputColor: "#050C1B",
  inputBackgroundColor: "#ffffff",
  inputFontWeight: 500,

  inputBorderColor: "#050C1B",
  inputBorderWidth: 1,
  inputBorderRadius: 0,

  inputHoverColor: "#050C1B",
  inputHoverBorderColor: "#050C1B",
  inputHoverBackgroundColor: "#ffffff",

  // **********************************
  //  Select field
  selectTopSpacing: 57,
  selectPaddingInline: 14,

  selectHeight: 45,
  selectWidth: '100',
  selectWidthUnits: "%",

  selectFontSize: 18,
  selectFontFamily: '"Raleway", sans-serif',
  selectColor: "#050C1B",
  selectBackgroundColor: "#F0F0F0",
  selectFontWeight: 500,

  selectBorderColor: "#050C1B",
  selectBorderWidth: 1,
  selectBorderRadius: 0,

  selectHoverColor: "#050C1B",
  selectHoverBorderColor: "#050C1B",
  selectHoverBackgroundColor: "#F0F0F0",

  addSelectBackgroundImage: false,
  selectBackgroundImage: '',
  selectBackgroundImagePositionRight: 10,
  selectBackgroundImageSize: 20,

  // **********************************
  //  Text Area field
  textAreaTopSpacing: 57,
  textAreaPaddingInline: 14,

  textAreaHeight: 218,
  textAreaWidth: '100',
  textAreaWidthUnits: "%",

  textAreaFontSize: 18,
  textAreaFontFamily: '"Raleway", sans-serif',
  textAreaColor: "#050C1B",
  textAreaBackgroundColor: "#ffffff",
  textAreaFontWeight: 500,

  textAreaBorderColor: "#050C1B",
  textAreaBorderWidth: 1,
  textAreaBorderRadius: 0,

  textAreaHoverColor: "#050C1B",
  textAreaHoverBorderColor: "#050C1B",
  textAreaHoverBackgroundColor: "#ffffff",

  // **********************************
  //  placeholder
  placeholderColor: "#050C1B",
  placeholderFontFamily: '"Raleway", sans-serif',
  placeholderFontSize: 18,
  placeholderFontWeight: 500,
  placeholderHoverColor: "#050C1B",

  // **********************************
  // script
  addPlaceholders: false,
  removeFieldLabels: false,

  // **********************************
  //  field label
  fieldLabelBottomSpacing: 12,
  fieldLabelPadding: 0,
  fieldLabelFontSize: 18,
  fieldLabelColor: "#050C1B",
  fieldLabelFontWeight: 500,
  fieldLabelColorAsterisk: "#050C1B",
  fieldLabelAlignment: "column",
  fieldLabelFontFamily: '"Raleway", sans-serif',

  // **********************************
  //  description
  descriptionPaddingInline: 0,
  descriptionColor: "#050C1B",
  descriptionFontSize: 18,
  descriptionFontWeight: 500,
  descriptionFontFamily: '"Raleway", sans-serif',
  descriptionTopSpacing: 10,

  // **********************************
  // checkbox

  addCheckbox: false,
  checkedCheckboxContent: "",
  checkboxInputSize: 18,
  checkboxBorderWidth: 1,
  checkboxBorderRadius: 0,
  checkboxUncheckedBorderColor: "#050C1B",
  checkboxUncheckedBackgroundColor: "#ffffff",
  checkboxCheckedBackgroundColor: "#1A57D8",
  checkboxCheckedBorderColor: "#050C1B",
  checkboxCheckedColor: "#ffffff",
  checkboxAlignment: "none",
  checkboxLabelFontFamily: '"Raleway", sans-serif',
  checkboxLabelFontSize: 18,
  checkboxLabelFontWeight: 500,
  checkboxLabelColor: "#050C1B",

  // **********************************
  // radio button

  addRadioButton: false,
  radioInputSize: 18,
  radioBorderWidth: 1,
  radioBorderRadius: 50,

  radioUncheckedBorderColor: "#050C1B",
  radioUncheckedBackgroundColor: "#ffffff",
  radioCheckedBackgroundColor: "#1A57D8",
  radioCheckedBorderColor: "#050C1B",

  radioAlignment: "none",

  radioLabelFontFamily: '"Raleway", sans-serif',
  radioLabelFontSize: 18,
  radioLabelFontWeight: 500,
  radioLabelColor: "#050C1B",

  // **********************************
  // submit button

  submitMarginTop: 43,
  submitFontSize: 16,
  submitFontFamily: "'Raleway', sans-serif",
  submitWidth: 128,
  submitWidthUnits: "px",
  submitHeight: 45,
  submitBorderRadius: 0,
  submitBorderWidth: 1,
  submitBackground: "#FFFFFF",
  submitColor: "#050C1B",
  submitBorderColor: "#1A57D8",
  submitBackgroundHover: "#FFFFFF",
  submitBorderColorHover: "#1A57D8",
  submitColorHover: "#050C1B",
  submitTextAlign: "center",
  submitButtonText: "Submit",
  submitFontWeight: 500,
  addBackgroundImage: false,
  submitBackgroundImage: '',
  submitBackgroundImagePositionRight: 10,
  submitBackgroundImageSize: 20,
  submitButtonAlign: "left",
};

  